import { render, staticRenderFns } from "./BizSupplier.vue?vue&type=template&id=06b41496&scoped=true&"
import script from "./BizSupplier.vue?vue&type=script&lang=js&"
export * from "./BizSupplier.vue?vue&type=script&lang=js&"
import style0 from "./BizSupplier.vue?vue&type=style&index=0&id=06b41496&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b41496",
  null
  
)

export default component.exports